/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';

export class GetReasonsToBuyDataInput extends Msdyn365.CommerceEntityInput implements Msdyn365.IActionInput {
    public categoryName:string ='';
    constructor( categoryName:string) {
        super({ shouldCacheOutput: true, cacheObjectType: 'rtbDataCache', cacheKey: 'rtbDataCache' });
        this.categoryName = categoryName;
    }
    public getCacheKey = () => `rtbDataCache`;
    public getCacheObjectType = () => 'rtbDataCache';
    public dataCacheType = (): Msdyn365.CacheType => 'request';

}
// tslint:disable: no-any
async function action(input: GetReasonsToBuyDataInput, ctx: Msdyn365.IActionContext): Promise<any> {
    const jsonUrlFromGlobals = ctx.requestContext.app.config.reasonsToBuyJsonUrl;
    const categoryName =input.categoryName;
    const jsonUrl =jsonUrlFromGlobals || undefined;
      if(jsonUrl){
        const res = await Msdyn365.sendRequest<any>(jsonUrl, 'get');
        const reasonsToBuyData =  res.data && res.data[categoryName];
        return  reasonsToBuyData;
      }
      return undefined;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<any>>action
});
